/* eslint-disable */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ArrowLeftButton = ({ className }) => (
  <SvgIcon viewBox='0 0 28 28' className={className}>
    <g id='Сгруппировать_2417' data-name='Сгруппировать 2417' transform='translate(-484 -800)'>
      <rect id='Прямоугольник_72028' data-name='Прямоугольник 72028' width='28' height='28' rx='7' transform='translate(484 800)' fill='rgba(0,133,255,0.1)' />
      <path id='Контур_13757' data-name='Контур 13757' d='M2360.908,1120.023l4.5,4.5,4.5-4.5' transform='translate(1620.523 -1550.908) rotate(90)' fill='none' stroke='#0085ff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
    </g>
  </SvgIcon>
);

export default ArrowLeftButton;
